const recaptcha = {
    on: import.meta.env.VITE_APP_RECAPTCHA_ON === 'true',
    apiKeyRecaptchaV2: import.meta.env.VITE_APP_RECAPTCHA_V2_SITE_KEY || ''
}

export default recaptcha
